import * as React from 'react';
import { BrowserRouter } from 'react-router-dom';
import { ThemeProvider } from '@mui/material/styles';
import Layout from './pages/layout';
import { Provider } from 'react-redux';
import store from './core/store/store';
import { Toaster } from 'react-hot-toast';
import theme from './pages/theme';
import { DateProvider } from './pages/ContextDateandTime/DateTimeContext';
import { Helmet } from 'react-helmet';
import { Typography, Button } from '@mui/material';
import logoAgent from '../public/assets/logo-agent.png';
import FaImageLink from '../public/assets/fa_image-link.png';
import InApp from 'detect-inapp';
import toast from 'react-hot-toast';
// import { useTheme } from '@mui/material/styles';
export default function App() {

    // const theme = useTheme();
    // const isDarkMode = theme.palette.mode === 'dark';
    const [isInAppBrowser, setIsInAppBrowser] = React.useState(false);

    React.useEffect(() => {
        const userAgent = navigator.userAgent || navigator.vendor || window.opera;
        const inApp = new InApp(userAgent);

        // Detect Facebook and Instagram in-app browsers (Android and iOS)
        const isFacebook =
            inApp.browser === 'facebook' ||
            inApp.browser === 'messenger' ||
            /FBAN|FBAV/.test(userAgent);
        const isInstagram =
            inApp.browser === 'instagram' ||
            /Instagram/.test(userAgent);
        const isTwitterDetect =
            inApp.browser === 'twitter' ||
            /Twitter/.test(userAgent);
        
        
        // Check for iPhone devices
        const isFacebookiOS =
            /FBAN|FBAV|FBIOS/i.test(userAgent) ||
            /FBDV\/iPhone/.test(userAgent);
        const isInstagramiOS =
            /Instagram/i.test(userAgent) &&
            /FBIOS/i.test(userAgent);
        // const isTwitteriOS =
        //     /Twitter/i.test(userAgent) &&
        //     /iPhone/i.test(userAgent);

        const inAppBrowserDetected = isFacebookiOS || isInstagramiOS || isFacebook || isInstagram || isTwitterDetect;

        if (inAppBrowserDetected) {
            setIsInAppBrowser(true);
            setTimeout(() => {
                // Check if the page is still blank and show an error message
                if (document.body.innerHTML.trim() === "") {
                    alert(
                        "It seems that the page isn't loading properly in the in-app browser. Please open this page in Chrome or Safari."
                    );
                } else {
                    console.log('Page content is loaded correctly.');
                }
            }, 2000); // 2-second delay to check if the page remains blank
        } else {
            setTimeout(() => {
                // Check if the page is still blank and show an error message
                if (document.body.innerHTML.trim() === "") {
                    alert(
                        "It seems that the page isn't loading properly. Please open this page in a standard browser like Chrome or Safari."
                    );
                } else {
                    console.log('Page content is loaded correctly.');
                }
            }, 8000); // 8-second delay to check if the page remains blank
        }

        console.log('Operating System:', inApp.os);
        console.log('Browser:', inApp.browser);
        console.log('User Agent:', userAgent);
    }, []);
    React.useEffect(() => {
        const userAgent = navigator.userAgent || navigator.vendor || window.opera;
        const inApp = new InApp(userAgent);

        const isTwitter = /Twitter|X\sapp/i.test(userAgent);
        const twitterPatterns = [
            /Twitter/i,
            /X\sapp/i,
            /TwitterAndroid/i,
            /TwitterMobile/i,
            /Twitter\sfor\siPhone/i,
            /X\sfor\siPhone/i,
            /X\sfor\siPad/i,
            /X\sfor\sAndroid/i,
            /TwitterWebView/i,
            /TwitterWebContainer/i,
            /XWEB/i,
            /TWTR/i
        ];
        const isTwitterPatterns = twitterPatterns.some(pattern => pattern.test(userAgent));
        const inAppBrowserDetected =  isTwitter || isTwitterPatterns

        if (inAppBrowserDetected) {
            setIsInAppBrowser(true);
        } 

    }, []);
    // const openInExternalBrowser = () => {
    //     const currentUrl = window.location.href.split("?")[0]; // Remove query params
    //     const isAndroid = /Android/.test(navigator.userAgent);
    //     const isIOS = /iPad|iPhone|iPod/.test(navigator.userAgent) && !window.MSStream;

    //     if (isAndroid) {
    //         // Open in Chrome on Android
    //         const intentUrl = `intent://${currentUrl.replace(/^https?:\/\//, "")}#Intent;scheme=https;package=com.android.chrome;end`;
    //         window.location.href = intentUrl;
    //     }else{
    //         // Open in Safari on iOS using a universal deep link method
    //         const safariUrl = `https://${currentUrl.replace(/^https?:\/\//, "")}`;
    //         window.location.assign(safariUrl);
    //         const safariUrlTest = `https://${currentUrl.replace(/^https?:\/\//, "")}`;
    //         window.open(safariUrlTest, '_blank');
    //     } 
    // };

    const currentUrl = window.location.href.split('?')[0]; // Get the base URL
    const copyLink = () => {
        navigator.clipboard.writeText(currentUrl).then(() => {
            alert('Link copied to clipboard!');
        }).catch(() => {
            alert('Failed to copy the link. Please try again');
        });
    };

    const shareLink = async () => {
        if (navigator.share) {
            try {
                await navigator.share({
                    url: currentUrl,
                });
            } catch (error) {
                alert('Something is Wrong. Please click again.');
            }
        } else {
            alert('Something is Wrong. Please try click again..');
        }
    };
    const getBasePath = () => {
        const pathname = window.location.pathname;
        if (pathname.startsWith("/tapTalkTour")) {
            return "/tapTalkTour";
        }
        return "/iconnctAdminPanel";
    };

    React.useEffect(() => {
        const pathname = window.location.pathname;
        if (pathname.startsWith("/iconnctAdminPanel/")) {
            document.title = "iCONNCT";
        } else {
            document.title = "iCONNCT";
        }
    }, [window.location.pathname]);

    return (
        <>
            <>
                {isInAppBrowser ? (
                    <div style={{ textAlign: "center", margin: "20px" }}>
                        <img
                            src={logoAgent}
                            alt="Logo"
                            style={{
                                width: "100%",
                                height: "auto",
                                maxWidth: "350px",
                                margin: "0 auto 16px",
                                display: "block",
                            }}
                        />
                        <Typography variant="h6" fontWeight="bold" sx={{ marginTop: "5px" }}>
                            Tap Talk Tour
                        </Typography>
                        <Typography variant="h6" fontWeight="bold" sx={{ marginTop: "5px" }}>
                            Tap Talk Sell
                        </Typography>
                        <img
                            src={FaImageLink}
                            alt="Logo"
                            style={{
                                width: "80%",
                                height: "85%",
                                maxWidth: "350px",
                                margin: "10px auto 16px", // Adjusted marginTop to 10px
                                display: "block",
                            }}
                        />
                        <Typography
                            variant="h6"
                            color="error"
                            sx={{ margin: "16px 0", textAlign: "center" }}
                        >
                            To connect directly with an agent, please tap "Copy" and open this link in your personal browser.
                        </Typography>
                        <div
                            style={{
                                position: "relative",
                                display: "flex",
                                alignItems: "center",
                                justifyContent: "center",
                                width: "260px", // Adjust width for input and button alignment
                                margin: "20px auto",
                            }}
                        >
                            <input
                                type="text"
                                value={currentUrl}
                                readOnly
                                style={{
                                    width: "100%",
                                    padding: "8px 70px 8px 10px", // Padding for button space
                                    border: "1px solid #ccc",
                                    borderRadius: "4px",
                                    fontSize: "14px",
                                    backgroundColor: "#f9f9f9",
                                    textOverflow: "ellipsis",
                                    overflow: "hidden",
                                    whiteSpace: "nowrap",
                                }}
                            />
                            <Button
                                variant="contained"
                                color="primary"
                                onClick={copyLink}
                                sx={{
                                    position: "absolute",
                                    right: "5px",
                                    top: "50%",
                                    transform: "translateY(-50%)",
                                    padding: "6px 12px",
                                    fontSize: "12px",
                                    borderRadius: "8px",
                                    textTransform: "none",
                                }}
                            >
                                Copy
                            </Button>
                        </div>

                        <Button
                            variant="contained"
                            color="secondary"
                            onClick={shareLink}
                            sx={{
                                borderRadius: "12px",
                                padding: "10px 20px",
                                marginTop: "10px",
                                color: "white",
                            }}
                        >
                            Share Link
                        </Button>
                    </div>
                ) : (
                    <>
                        <Helmet>
                            <title>iCONNCT</title>
                        </Helmet>
                        <Toaster />
                        <BrowserRouter basename={getBasePath()}>
                            <ThemeProvider theme={theme}>
                                <Provider store={store}>
                                    <DateProvider>
                                        <Layout />
                                    </DateProvider>
                                </Provider>
                            </ThemeProvider>
                        </BrowserRouter>
                    </>
                )}
            </>
        </>
    );

}